/** Таймеры показа баннера */
export type TViewShowTimeouts = Record<'view1' | 'view2', null | ReturnType<typeof setTimeout>>;

/** Очистка таймеров показа баннера */
export function clearViewTimeouts(timeouts: TViewShowTimeouts): void {
  if (timeouts.view1 !== null) {
    clearTimeout(timeouts.view1);
    timeouts.view1 = null;
  }

  if (timeouts.view2 !== null) {
    clearTimeout(timeouts.view2);
    timeouts.view2 = null;
  }
}
